/**
 * Porte du consentement. Ce n'est PAS une CMP conforme TCF : c'est l'emplacement
 * prevu par le CLAUDE.md, avec la bonne forme et le bon cablage, pour qu'y
 * brancher une vraie CMP soit un remplacement et non une reecriture.
 *
 * Regle : rien qui touche a la publicite ne demarre sans `granted === true`.
 *
 * PLUS AUCUNE INTERFACE NE L'ALIMENTE. Le bandeau maison a ete retire : il
 * n'avait aucune valeur juridique, et en afficher un faux revenait a faire
 * croire a un choix qui n'existait pas. Le statut reste donc `unknown`, donc
 * `initAds(false)`, donc aucune publicite. C'est l'etat correct tant que la
 * CMP certifiee de Google n'est pas branchee : le site ne charge aujourd'hui
 * aucun script tiers et ne depose aucun traceur.
 *
 * A l'integration de la CMP : c'est elle qui appellera `accept()` / `decline()`
 * en lisant le signal TCF (`__tcfapi`), et elle qui portera le lien de retrait
 * du consentement que les pages legales promettent.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ConsentStatus = 'unknown' | 'granted' | 'denied';

interface ConsentState {
  status: ConsentStatus;
  accept(): void;
  decline(): void;
  /** Rouvre le bandeau (lien depuis les pages legales). */
  reset(): void;
}

export const useConsentStore = create<ConsentState>()(
  persist(
    (set) => ({
      status: 'unknown',
      accept: () => set({ status: 'granted' }),
      decline: () => set({ status: 'denied' }),
      reset: () => set({ status: 'unknown' }),
    }),
    {
      name: 'retusch:consent',
      partialize: (state) => ({ status: state.status }),
    },
  ),
);

export function hasConsent(): boolean {
  return useConsentStore.getState().status === 'granted';
}
